module.exports = __webpack_public_path__ + "assets/img/12.b7c5ba50.png";